import React, { useEffect, useState, FunctionComponent } from 'react';

export const Facet = props => {
  const { controller, facet, type = 'with-checkbox-and-results' } = props;
  const [state, setState] = useState(controller.state);

  useEffect(() => controller.subscribe(() => setState(controller.state)), []);

  if (!state.values.length) {
    return <div>No facet values</div>;
  }

  const handleFacetClick = value => {
    if (facet.isSingleSelect) controller.toggleSingleSelect(value);
    else controller.toggleSelect(value);
  };

  const renderFacet = value => {
    //type is one of
    //'with-checkbox-and-results'
    //'with-results'
    //'with-checkbox'
    return (
      <div
        className={`listing-row-facet listing-row-facet--${
          facet.isSingleSelect ? 'with-results' : 'with-checkbox-and-results'
        } ${
          controller.isValueSelected(value) ? 'listing-row-facet--selected' : ''
        } ${state.isLoading ? 'listing-row-facet--loading' : ''}`}
        onClick={() => handleFacetClick(value)}
      >
        <input
          type="checkbox"
          className="listing-row-facet__checkbox-input"
          value={value}
          aria-label={value.value}
          tabIndex="-1"
          disabled={state.isLoading}
          defaultChecked={controller.isValueSelected(value)}
        />
        <button
          className="listing-row-facet__checkbox-button"
          aria-label={value.value}
          disabled={state.isLoading}
          aria-checked={controller.isValueSelected(value)}
        ></button>
        <label
          className="listing-row-facet__label"
          title={value.value}
          aria-hidden="false"
        >
          {value.value}
        </label>
        <span className="listing-row-facet__results" aria-hidden="true">
          {value.numberOfResults}
        </span>
      </div>
    );
  };

  return (
    <fieldset className="listing-row-facet-group">
      {facet.title && (
        <div>
          <legend className="listing-row-facet-group__title">
            {facet.title}
          </legend>
        </div>
      )}
      <ul>
        <li>
          <ul>
            {state.values.map(value => (
              <li key={value.value}>{renderFacet(value)}</li>
            ))}
          </ul>
        </li>
      </ul>
    </fieldset>
  );
};
